import { Provider } from '@angular/core';

import { RoomAdaptApiService } from '../api';

import { MockRoomAdaptApiService } from './mock-room-adapt-api.service';

export function provideRoomAdaptDataAccessMock(): Provider[] {
	return [{ provide: RoomAdaptApiService, useClass: MockRoomAdaptApiService }];
}
